import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { isArray } from 'lodash';

@Injectable()
export class CoursService {
    private sub: any;
    constructor() {
    }

    // Recherche la durée du cours en fonction de l'année scolaire, de la discipline, du cycle et du niveau
    // (année, discipline et cycle obligatoire pour lancer la recherche)
    loadDureeCours(http: HttpClient, form) {
        // console.log({ where: 'loadDureeCours', form});
        const criteria = {
            disciplineId: form.value && form.value.discipline ? form.value.discipline.id : null,
            cycleId: form.value && form.value.cycleCours ? form.value.cycleCours : null,
            niveauId: form.value && form.value.niveauCours ? form.value.niveauCours : null,
            anneeScolaire: form.value.anneeScolaire,
        }
        // console.log({ where: 'loadCursus', cours: form.value, criteria });
        if (this.sub) {
            this.sub.unsubscribe();
        }
        // Ne lancer la recherche que si disciplineId et cycleId renseignés
        if (criteria.disciplineId && criteria.cycleId) {
            this.sub = http.get(
                environment.proxyUrl + '/cursus/searchCursusNiveauByCriteria',
                {
                    params: {
                        'params': JSON.stringify([criteria]),
                    }
                }).subscribe(data => {
                    console.log({
                        where: 'searchCursusNiveauByCriteria', data
                    });
                    if (isArray(data)) {
                        const listCursusNiveau: Array<any> = data;
                        const dureesCours = listCursusNiveau.map(e => { return e.dureeCours })
                            .reduce((unique, item) => unique.includes(item) ? unique : [...unique, item], []);
                        if (dureesCours.length == 1) {
                            form.patchValue({ duree: +dureesCours[0] })
                        }
                        console.log({ dureesCours, form });
                    }
                })
        }
    }
    getSelectOptions(selectOptions) {
        return {
            'discipline': {options: [
                {label: '', value: null},
                ...(selectOptions.disciplines ? selectOptions.disciplines : []).map(discipline => {
                    return {
                        label: discipline.label, value: {id: discipline.value}
                    };
                })
            ]},
            'professeur': {options: [
                {label: '', value: null},
                ...(selectOptions.professeurs ? selectOptions.professeurs : []).map(professeur => {
                    return {label: professeur.label, value: {id: professeur.value}}
                })
            ]},
            'accompagnateur': {options: [
                {label: '', value: null},
                ...(selectOptions.professeurs ? selectOptions.professeurs : []).map(professeur => {
                    return {label: professeur.label, value: {id: professeur.value}}
                })
            ]},
            'salle': {options: [
                {label: '', value: null},
                ...(selectOptions.salles ? selectOptions.salles : []).map(salle => {
                    return {label: salle.label, value: {id: salle.value}}
                })
            ]},
            'cycleCours': {options: [
                {label: '', value: null},
                ...selectOptions.cycles
            ]},
            'niveauCours': {options: [
                {label: '', value: null},
                ...selectOptions.niveaux
            ]},
        }
    }
}


// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/shared/services/cours.service.ts